import React, { FC, useContext } from "react";
import { Box, Typography } from "@mui/material";
import { LanguageContext } from "common/contexts/LanguageContext";
import useProjectStore from "common/store/ProjectStore";
import PlanningToolbar from "../toolbar/PlanningToolbar";

const Header: FC = () => {
  const { getString } = useContext(LanguageContext);
  const { projectName:projectName } = useProjectStore();

  return (
    <>
      <Typography variant="h5" component="div">
        <Box sx={{ textTransform: "uppercase", fontWeight: "bold" }}>
          {getString("wlcm_title")}
        </Box>
      </Typography>
      <Typography variant="body1" align="right" sx={{ mt: "-6px", mb: "4px" }}>
        {projectName}
      </Typography>
      <PlanningToolbar />
    </>
  );
};

export default Header;
